import { flow } from "fp-ts/lib/function";

import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { getInsightsDiffPct, safeDivide } from "../math";
import { type AverageStatPair, type InsightsMetrics, type StatsItem } from "../models";

const safeDivideAverageStatPairs = ([a, b]: [AverageStatPair, AverageStatPair]): [number, number] => [
    safeDivide(a.stat, a.lensPlays),
    safeDivide(b.stat, b.lensPlays),
];

const getCurrPrevInsightsDiffPct = ([curr, prev]: [number, number]) => getInsightsDiffPct(curr, prev);

export const mapAverageStatDiffValue =
    (averageStatPairs: [AverageStatPair, AverageStatPair], isLifetime: boolean) =>
    (computedMetric: InsightsMetrics<StatsItem>): InsightsMetrics<StatsItem> => {
        if (isLifetime) {
            return computedMetric;
        }

        const diffValue = flow(
            safeDivideAverageStatPairs,
            getCurrPrevInsightsDiffPct,
            formatSignedPctNumber,
        )(averageStatPairs);

        return {
            ...computedMetric,
            diffValue,
        };
    };
